module.exports = __webpack_public_path__ + "img/submissionGallery.3019a2c9.png";